import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuestionnaireAnswer } from '../../models/questionnaires/questionnaire-answer.model';
import { QuestionnaireType } from '../../models/questionnaires/questionnaire-type.enum';
import { Questionnaire } from '../../models/questionnaires/questionnaire.model';
import { DeserializationUtils } from '../../utils/deserialization-utils';
import { SessionStorageService } from 'app/core/services/session-storage-service';

@Injectable({ providedIn: 'root' })
export class QuestionnaireService {
  private readonly BASE_PATH = '/ws/integrated/v1/ordering/questionnaire';

  constructor(private http: HttpClient, private sessionStorageService: SessionStorageService) {}

  fetchQuestionnaire(type: QuestionnaireType, name?: string, zzz?: string): Observable<Questionnaire> {
    let params: HttpParams = new HttpParams().set('type', type);

    if (name) {
      params = params.set('name', name);
    }

    if (zzz) {
      params = params.set('zzz', zzz);
    }

    return this.http.get(this.BASE_PATH, { params }).pipe(
      map((json: Object) => DeserializationUtils.deserializeObj(json, Questionnaire)),
      map((questionnaire: Questionnaire) => {
        questionnaire.initQuestionnaireResponses();

        return questionnaire;
      })
    );
  }

  answerQuestionnaire(questionnaireAnswer: QuestionnaireAnswer): Observable<HttpResponse<string>> {
    const answer = questionnaireAnswer;
    answer.subscriptionSource = this.sessionStorageService.getSubscriptionSource();

    return this.http
      .post(this.BASE_PATH, answer.serialize(), {
        observe: 'response',
        responseType: 'text',
      })
      .pipe(
        map((response: HttpResponse<string>) => {
          const linkifiedBody = this.linkify(response.body ?? '');

          return response.clone({
            body: linkifiedBody,
          });
        })
      );
  }

  private linkify(text: string): string {
    if (!text) return text;

    const urlRegex = /(https?:\/\/|www\.)\S+/gi;

    return text.replace(urlRegex, url => {
      const href = url.startsWith('http') ? url : `https://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
}
